function errorAddToCartApp() {
  return {
    show: false,
    error: null,
    heading: 'Error',
    init() {
      document.addEventListener('errorAddToCart', (e) => {
        const _errorObj = e.detail.error;
        let _error = '';
        if (_errorObj.response) {
          _error = _errorObj.response.data.description;
          this.heading = _errorObj.response.data.message;
        } else {
          _error = _errorObj.message;
        }
        this.error = _error;
        this.show = true;
      });
    },
  };
}
